/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as MessetascheIndexRouteImport } from './routes/messetasche/index'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as MessetascheTokenIndexRouteImport } from './routes/messetasche/$token/index'
import { Route as InviteTokenIndexRouteImport } from './routes/invite/$token/index'
import { Route as ConfirmTokenIndexRouteImport } from './routes/confirm/$token/index'
import { Route as AuthenticatedWebhooksIndexRouteImport } from './routes/_authenticated/webhooks/index'
import { Route as AuthenticatedTeamIndexRouteImport } from './routes/_authenticated/team/index'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedProfilIndexRouteImport } from './routes/_authenticated/profil/index'
import { Route as AuthenticatedLeadsIndexRouteImport } from './routes/_authenticated/leads/index'
import { Route as AuthenticatedEventsIndexRouteImport } from './routes/_authenticated/events/index'
import { Route as AuthenticatedApiKeysIndexRouteImport } from './routes/_authenticated/api-keys/index'
import { Route as AuthenticatedEventsNewRouteImport } from './routes/_authenticated/events/new'
import { Route as MessetascheBestaetigenDoiTokenIndexRouteImport } from './routes/messetasche/bestaetigen/$doiToken/index'
import { Route as FormTenantSlugEventSlugIndexRouteImport } from './routes/form/$tenantSlug/$eventSlug/index'
import { Route as AuthenticatedEventsEventIdIndexRouteImport } from './routes/_authenticated/events/$eventId/index'
import { Route as AuthenticatedEventsEventIdSettingsRouteImport } from './routes/_authenticated/events/$eventId/settings'
import { Route as AuthenticatedEventsEventIdLeadsRouteImport } from './routes/_authenticated/events/$eventId/leads'
import { Route as STenantSlugEventSlugExhibitorSlugIndexRouteImport } from './routes/s/$tenantSlug/$eventSlug/$exhibitorSlug/index'

const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const MessetascheIndexRoute = MessetascheIndexRouteImport.update({
  id: '/messetasche/',
  path: '/messetasche/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const MessetascheTokenIndexRoute = MessetascheTokenIndexRouteImport.update({
  id: '/messetasche/$token/',
  path: '/messetasche/$token/',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteTokenIndexRoute = InviteTokenIndexRouteImport.update({
  id: '/invite/$token/',
  path: '/invite/$token/',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfirmTokenIndexRoute = ConfirmTokenIndexRouteImport.update({
  id: '/confirm/$token/',
  path: '/confirm/$token/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedWebhooksIndexRoute =
  AuthenticatedWebhooksIndexRouteImport.update({
    id: '/webhooks/',
    path: '/webhooks/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTeamIndexRoute = AuthenticatedTeamIndexRouteImport.update({
  id: '/team/',
  path: '/team/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfilIndexRoute =
  AuthenticatedProfilIndexRouteImport.update({
    id: '/profil/',
    path: '/profil/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLeadsIndexRoute = AuthenticatedLeadsIndexRouteImport.update({
  id: '/leads/',
  path: '/leads/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedEventsIndexRoute =
  AuthenticatedEventsIndexRouteImport.update({
    id: '/events/',
    path: '/events/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedApiKeysIndexRoute =
  AuthenticatedApiKeysIndexRouteImport.update({
    id: '/api-keys/',
    path: '/api-keys/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEventsNewRoute = AuthenticatedEventsNewRouteImport.update({
  id: '/events/new',
  path: '/events/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const MessetascheBestaetigenDoiTokenIndexRoute =
  MessetascheBestaetigenDoiTokenIndexRouteImport.update({
    id: '/messetasche/bestaetigen/$doiToken/',
    path: '/messetasche/bestaetigen/$doiToken/',
    getParentRoute: () => rootRouteImport,
  } as any)
const FormTenantSlugEventSlugIndexRoute =
  FormTenantSlugEventSlugIndexRouteImport.update({
    id: '/form/$tenantSlug/$eventSlug/',
    path: '/form/$tenantSlug/$eventSlug/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthenticatedEventsEventIdIndexRoute =
  AuthenticatedEventsEventIdIndexRouteImport.update({
    id: '/events/$eventId/',
    path: '/events/$eventId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEventsEventIdSettingsRoute =
  AuthenticatedEventsEventIdSettingsRouteImport.update({
    id: '/events/$eventId/settings',
    path: '/events/$eventId/settings',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEventsEventIdLeadsRoute =
  AuthenticatedEventsEventIdLeadsRouteImport.update({
    id: '/events/$eventId/leads',
    path: '/events/$eventId/leads',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const STenantSlugEventSlugExhibitorSlugIndexRoute =
  STenantSlugEventSlugExhibitorSlugIndexRouteImport.update({
    id: '/s/$tenantSlug/$eventSlug/$exhibitorSlug/',
    path: '/s/$tenantSlug/$eventSlug/$exhibitorSlug/',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/messetasche/': typeof MessetascheIndexRoute
  '/events/new': typeof AuthenticatedEventsNewRoute
  '/api-keys/': typeof AuthenticatedApiKeysIndexRoute
  '/events/': typeof AuthenticatedEventsIndexRoute
  '/leads/': typeof AuthenticatedLeadsIndexRoute
  '/profil/': typeof AuthenticatedProfilIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/team/': typeof AuthenticatedTeamIndexRoute
  '/webhooks/': typeof AuthenticatedWebhooksIndexRoute
  '/confirm/$token/': typeof ConfirmTokenIndexRoute
  '/invite/$token/': typeof InviteTokenIndexRoute
  '/messetasche/$token/': typeof MessetascheTokenIndexRoute
  '/events/$eventId/leads': typeof AuthenticatedEventsEventIdLeadsRoute
  '/events/$eventId/settings': typeof AuthenticatedEventsEventIdSettingsRoute
  '/events/$eventId/': typeof AuthenticatedEventsEventIdIndexRoute
  '/form/$tenantSlug/$eventSlug/': typeof FormTenantSlugEventSlugIndexRoute
  '/messetasche/bestaetigen/$doiToken/': typeof MessetascheBestaetigenDoiTokenIndexRoute
  '/s/$tenantSlug/$eventSlug/$exhibitorSlug/': typeof STenantSlugEventSlugExhibitorSlugIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/messetasche': typeof MessetascheIndexRoute
  '/events/new': typeof AuthenticatedEventsNewRoute
  '/api-keys': typeof AuthenticatedApiKeysIndexRoute
  '/events': typeof AuthenticatedEventsIndexRoute
  '/leads': typeof AuthenticatedLeadsIndexRoute
  '/profil': typeof AuthenticatedProfilIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/team': typeof AuthenticatedTeamIndexRoute
  '/webhooks': typeof AuthenticatedWebhooksIndexRoute
  '/confirm/$token': typeof ConfirmTokenIndexRoute
  '/invite/$token': typeof InviteTokenIndexRoute
  '/messetasche/$token': typeof MessetascheTokenIndexRoute
  '/events/$eventId/leads': typeof AuthenticatedEventsEventIdLeadsRoute
  '/events/$eventId/settings': typeof AuthenticatedEventsEventIdSettingsRoute
  '/events/$eventId': typeof AuthenticatedEventsEventIdIndexRoute
  '/form/$tenantSlug/$eventSlug': typeof FormTenantSlugEventSlugIndexRoute
  '/messetasche/bestaetigen/$doiToken': typeof MessetascheBestaetigenDoiTokenIndexRoute
  '/s/$tenantSlug/$eventSlug/$exhibitorSlug': typeof STenantSlugEventSlugExhibitorSlugIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/messetasche/': typeof MessetascheIndexRoute
  '/_authenticated/events/new': typeof AuthenticatedEventsNewRoute
  '/_authenticated/api-keys/': typeof AuthenticatedApiKeysIndexRoute
  '/_authenticated/events/': typeof AuthenticatedEventsIndexRoute
  '/_authenticated/leads/': typeof AuthenticatedLeadsIndexRoute
  '/_authenticated/profil/': typeof AuthenticatedProfilIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/team/': typeof AuthenticatedTeamIndexRoute
  '/_authenticated/webhooks/': typeof AuthenticatedWebhooksIndexRoute
  '/confirm/$token/': typeof ConfirmTokenIndexRoute
  '/invite/$token/': typeof InviteTokenIndexRoute
  '/messetasche/$token/': typeof MessetascheTokenIndexRoute
  '/_authenticated/events/$eventId/leads': typeof AuthenticatedEventsEventIdLeadsRoute
  '/_authenticated/events/$eventId/settings': typeof AuthenticatedEventsEventIdSettingsRoute
  '/_authenticated/events/$eventId/': typeof AuthenticatedEventsEventIdIndexRoute
  '/form/$tenantSlug/$eventSlug/': typeof FormTenantSlugEventSlugIndexRoute
  '/messetasche/bestaetigen/$doiToken/': typeof MessetascheBestaetigenDoiTokenIndexRoute
  '/s/$tenantSlug/$eventSlug/$exhibitorSlug/': typeof STenantSlugEventSlugExhibitorSlugIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/register'
    | '/dashboard'
    | '/messetasche/'
    | '/events/new'
    | '/api-keys/'
    | '/events/'
    | '/leads/'
    | '/profil/'
    | '/settings/'
    | '/team/'
    | '/webhooks/'
    | '/confirm/$token/'
    | '/invite/$token/'
    | '/messetasche/$token/'
    | '/events/$eventId/leads'
    | '/events/$eventId/settings'
    | '/events/$eventId/'
    | '/form/$tenantSlug/$eventSlug/'
    | '/messetasche/bestaetigen/$doiToken/'
    | '/s/$tenantSlug/$eventSlug/$exhibitorSlug/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/register'
    | '/dashboard'
    | '/messetasche'
    | '/events/new'
    | '/api-keys'
    | '/events'
    | '/leads'
    | '/profil'
    | '/settings'
    | '/team'
    | '/webhooks'
    | '/confirm/$token'
    | '/invite/$token'
    | '/messetasche/$token'
    | '/events/$eventId/leads'
    | '/events/$eventId/settings'
    | '/events/$eventId'
    | '/form/$tenantSlug/$eventSlug'
    | '/messetasche/bestaetigen/$doiToken'
    | '/s/$tenantSlug/$eventSlug/$exhibitorSlug'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/login'
    | '/register'
    | '/_authenticated/dashboard'
    | '/messetasche/'
    | '/_authenticated/events/new'
    | '/_authenticated/api-keys/'
    | '/_authenticated/events/'
    | '/_authenticated/leads/'
    | '/_authenticated/profil/'
    | '/_authenticated/settings/'
    | '/_authenticated/team/'
    | '/_authenticated/webhooks/'
    | '/confirm/$token/'
    | '/invite/$token/'
    | '/messetasche/$token/'
    | '/_authenticated/events/$eventId/leads'
    | '/_authenticated/events/$eventId/settings'
    | '/_authenticated/events/$eventId/'
    | '/form/$tenantSlug/$eventSlug/'
    | '/messetasche/bestaetigen/$doiToken/'
    | '/s/$tenantSlug/$eventSlug/$exhibitorSlug/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
  MessetascheIndexRoute: typeof MessetascheIndexRoute
  ConfirmTokenIndexRoute: typeof ConfirmTokenIndexRoute
  InviteTokenIndexRoute: typeof InviteTokenIndexRoute
  MessetascheTokenIndexRoute: typeof MessetascheTokenIndexRoute
  FormTenantSlugEventSlugIndexRoute: typeof FormTenantSlugEventSlugIndexRoute
  MessetascheBestaetigenDoiTokenIndexRoute: typeof MessetascheBestaetigenDoiTokenIndexRoute
  STenantSlugEventSlugExhibitorSlugIndexRoute: typeof STenantSlugEventSlugExhibitorSlugIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/messetasche/': {
      id: '/messetasche/'
      path: '/messetasche'
      fullPath: '/messetasche/'
      preLoaderRoute: typeof MessetascheIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/messetasche/$token/': {
      id: '/messetasche/$token/'
      path: '/messetasche/$token'
      fullPath: '/messetasche/$token/'
      preLoaderRoute: typeof MessetascheTokenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/$token/': {
      id: '/invite/$token/'
      path: '/invite/$token'
      fullPath: '/invite/$token/'
      preLoaderRoute: typeof InviteTokenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/confirm/$token/': {
      id: '/confirm/$token/'
      path: '/confirm/$token'
      fullPath: '/confirm/$token/'
      preLoaderRoute: typeof ConfirmTokenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/webhooks/': {
      id: '/_authenticated/webhooks/'
      path: '/webhooks'
      fullPath: '/webhooks/'
      preLoaderRoute: typeof AuthenticatedWebhooksIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/team/': {
      id: '/_authenticated/team/'
      path: '/team'
      fullPath: '/team/'
      preLoaderRoute: typeof AuthenticatedTeamIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profil/': {
      id: '/_authenticated/profil/'
      path: '/profil'
      fullPath: '/profil/'
      preLoaderRoute: typeof AuthenticatedProfilIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/leads/': {
      id: '/_authenticated/leads/'
      path: '/leads'
      fullPath: '/leads/'
      preLoaderRoute: typeof AuthenticatedLeadsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/events/': {
      id: '/_authenticated/events/'
      path: '/events'
      fullPath: '/events/'
      preLoaderRoute: typeof AuthenticatedEventsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/api-keys/': {
      id: '/_authenticated/api-keys/'
      path: '/api-keys'
      fullPath: '/api-keys/'
      preLoaderRoute: typeof AuthenticatedApiKeysIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/events/new': {
      id: '/_authenticated/events/new'
      path: '/events/new'
      fullPath: '/events/new'
      preLoaderRoute: typeof AuthenticatedEventsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/messetasche/bestaetigen/$doiToken/': {
      id: '/messetasche/bestaetigen/$doiToken/'
      path: '/messetasche/bestaetigen/$doiToken'
      fullPath: '/messetasche/bestaetigen/$doiToken/'
      preLoaderRoute: typeof MessetascheBestaetigenDoiTokenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/form/$tenantSlug/$eventSlug/': {
      id: '/form/$tenantSlug/$eventSlug/'
      path: '/form/$tenantSlug/$eventSlug'
      fullPath: '/form/$tenantSlug/$eventSlug/'
      preLoaderRoute: typeof FormTenantSlugEventSlugIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/events/$eventId/': {
      id: '/_authenticated/events/$eventId/'
      path: '/events/$eventId'
      fullPath: '/events/$eventId/'
      preLoaderRoute: typeof AuthenticatedEventsEventIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/events/$eventId/settings': {
      id: '/_authenticated/events/$eventId/settings'
      path: '/events/$eventId/settings'
      fullPath: '/events/$eventId/settings'
      preLoaderRoute: typeof AuthenticatedEventsEventIdSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/events/$eventId/leads': {
      id: '/_authenticated/events/$eventId/leads'
      path: '/events/$eventId/leads'
      fullPath: '/events/$eventId/leads'
      preLoaderRoute: typeof AuthenticatedEventsEventIdLeadsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/s/$tenantSlug/$eventSlug/$exhibitorSlug/': {
      id: '/s/$tenantSlug/$eventSlug/$exhibitorSlug/'
      path: '/s/$tenantSlug/$eventSlug/$exhibitorSlug'
      fullPath: '/s/$tenantSlug/$eventSlug/$exhibitorSlug/'
      preLoaderRoute: typeof STenantSlugEventSlugExhibitorSlugIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedEventsNewRoute: typeof AuthenticatedEventsNewRoute
  AuthenticatedApiKeysIndexRoute: typeof AuthenticatedApiKeysIndexRoute
  AuthenticatedEventsIndexRoute: typeof AuthenticatedEventsIndexRoute
  AuthenticatedLeadsIndexRoute: typeof AuthenticatedLeadsIndexRoute
  AuthenticatedProfilIndexRoute: typeof AuthenticatedProfilIndexRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
  AuthenticatedTeamIndexRoute: typeof AuthenticatedTeamIndexRoute
  AuthenticatedWebhooksIndexRoute: typeof AuthenticatedWebhooksIndexRoute
  AuthenticatedEventsEventIdLeadsRoute: typeof AuthenticatedEventsEventIdLeadsRoute
  AuthenticatedEventsEventIdSettingsRoute: typeof AuthenticatedEventsEventIdSettingsRoute
  AuthenticatedEventsEventIdIndexRoute: typeof AuthenticatedEventsEventIdIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedEventsNewRoute: AuthenticatedEventsNewRoute,
  AuthenticatedApiKeysIndexRoute: AuthenticatedApiKeysIndexRoute,
  AuthenticatedEventsIndexRoute: AuthenticatedEventsIndexRoute,
  AuthenticatedLeadsIndexRoute: AuthenticatedLeadsIndexRoute,
  AuthenticatedProfilIndexRoute: AuthenticatedProfilIndexRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  AuthenticatedTeamIndexRoute: AuthenticatedTeamIndexRoute,
  AuthenticatedWebhooksIndexRoute: AuthenticatedWebhooksIndexRoute,
  AuthenticatedEventsEventIdLeadsRoute: AuthenticatedEventsEventIdLeadsRoute,
  AuthenticatedEventsEventIdSettingsRoute:
    AuthenticatedEventsEventIdSettingsRoute,
  AuthenticatedEventsEventIdIndexRoute: AuthenticatedEventsEventIdIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
  MessetascheIndexRoute: MessetascheIndexRoute,
  ConfirmTokenIndexRoute: ConfirmTokenIndexRoute,
  InviteTokenIndexRoute: InviteTokenIndexRoute,
  MessetascheTokenIndexRoute: MessetascheTokenIndexRoute,
  FormTenantSlugEventSlugIndexRoute: FormTenantSlugEventSlugIndexRoute,
  MessetascheBestaetigenDoiTokenIndexRoute:
    MessetascheBestaetigenDoiTokenIndexRoute,
  STenantSlugEventSlugExhibitorSlugIndexRoute:
    STenantSlugEventSlugExhibitorSlugIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
